import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/datetime/x-date-picker-dropdown.js';
import '@adornis/forms/x-radiogroup.js';
import '@adornis/popover/x-tooltip.js';

import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-checkbox.js';
import '@chancenwerk/design/components/cr-date-picker-dropdown.js';
import '@chancenwerk/design/components/cr-dropdown-multiselection.js';
import '@chancenwerk/design/components/cr-dropdown-selection.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-grid.js';
import '@chancenwerk/design/components/cr-icon.js';
import '@chancenwerk/design/components/cr-input.js';
import '@chancenwerk/design/components/cr-toggle-button.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef, ref, type Ref } from 'lit/directives/ref.js';
import { languages } from '../../../../src/client/translation-data.js';
import '../../../../src/print-components/chancen-component-anmeldung-consent.js';
import '../components/anmeldung-component-formular.js';
import type { AnmeldungPageRegistration } from '../components/anmeldung-component-formular.js';
import '../components/consent-texts/anmeldung-component-formfield-consent-eval.js';
import '../components/consent-texts/anmeldung-component-formfield-consent-picture.js';
import '../cr-cta-text.js';

/**
 * @customElement anmeldung-page-registration-os
 */
@customElement('anmeldung-page-registration-os')
export class AnmeldungPageRegistrationOS extends ChemistryLitElement {
  size = new WindowSizeController(this);

  @property({ attribute: false }) selectedLanguage = new RXController(this, languages.german);

  formularRef: Ref<AnmeldungPageRegistration> = createRef();

  public override render() {
    return html`
      <cr-flex crossaxis-center h100 w100>
        <anmeldung-component-formular .selectedLanguage=${this.selectedLanguage} step=${1} ${ref(this.formularRef)}>
        </anmeldung-component-formular>
      </cr-flex>
    `;
  }

  override firstUpdated(arg) {
    super.firstUpdated(arg);

    if (this.formularRef.value) {
      this.formularRef.value.schoolLevel.next('os');
    }
  }

  override styles() {
    return [
      {
        ':host': { display: 'block', height: '100%' },
      },
    ];
  }
}
